var ANIMATION = {
  defaultTiming: '350ms'
};

export { ANIMATION as default };
